var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiskette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 0C0.559644 0 0 0.559644 0 1.25V8.75C0 9.44036 0.559644 10 1.25 10H8.75C9.44036 10 10 9.44036 10 8.75V3.01777C10 2.68625 9.8683 2.3683 9.63388 2.13388L7.86612 0.366117C7.6317 0.131696 7.31376 0 6.98223 0H1.25ZM7.5 1.66667H1.66667V3.33333H7.5V1.66667ZM5 7.85714C5.78898 7.85714 6.42857 7.21755 6.42857 6.42857C6.42857 5.63959 5.78898 5 5 5C4.21102 5 3.57143 5.63959 3.57143 6.42857C3.57143 7.21755 4.21102 7.85714 5 7.85714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskette);
export default __webpack_public_path__ + "static/media/diskette.95dcd0293a6347b1ce59610cd9d4a78b.svg";
export { ForwardRef as ReactComponent };